/* Fransk katalog for locale-transaction-detail-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'transaction.annulBy': 'Annulé par',
  "transaction.annulAudit": "Historique d’annulation",
  "transaction.annulledAt": "Annulé le",
  "transaction.annulReason": "Motif",
  "transaction.annulActor": "Identifiant utilisateur",
  "transaction.reversalDate": "Date comptable de la contre-passation",
  "transaction.openOriginal": "Ouvrir l’écriture d’origine",
  "transaction.openReversal": "Ouvrir la contre-passation",
  "transaction.auditMissing": "Non enregistré",
  "transaction.reversalMissing": "La contre-passation est indisponible dans le journal chargé.",
  "transaction.auditDebit": "Débit",
  "transaction.auditCredit": "Crédit",

  'transaction.incompleteBasis': 'La couverture du journal est incomplète. Ce justificatif est affiché à des fins de documentation et de diagnostic ; les totaux ne doivent pas être considérés comme complets.',
  'route.transaction': 'Transaction',
  'transaction.back': 'Retour à toutes les transactions',
  'transaction.title': 'Transaction',
  'transaction.posting': 'Écriture',
  'transaction.summary': 'Récapitulatif – montants entrant et sortant des comptes',
  'transaction.account': 'Compte',
  'transaction.incoming': 'Entrée sur le compte',
  'transaction.outgoing': 'Sortie du compte',
  'transaction.total': 'Total',
  'transaction.description': 'Description',
  'transaction.links': 'Éléments liés',
  'transaction.sourceLead': 'Il s\'agit de la comptabilisation de',
  'transaction.sourceHelp': 'Ouvrez la source pour modifier la transaction ou un paiement lié.',
  'transaction.relatedPayments': 'Paiements associés',
  'transaction.correctionReplacement': 'Justificatif de remplacement',
  'transaction.correctionOriginal': 'Justificatif d\'origine',
  'transaction.correctionReason': 'Motif de la correction',
  'transaction.created': 'Créé',
  'transaction.by': 'par',
  'transaction.vatCodes': 'Codes TVA',
  'transaction.accountNumber': 'N° de compte',
  'transaction.name': 'Nom',
  'transaction.amount': 'Montant',
  'transaction.documentation': 'Documentation',
  'transaction.generatedDocument': 'Le document de facture est généré lorsque vous l\'ouvrez ou le téléchargez.',
  'transaction.noDocumentation': 'Aucune documentation n\'est jointe à cette transaction.',
  'transaction.open': 'Écriture ouverte',
  'transaction.locked': 'Écriture verrouillée',
  'transaction.annulled': 'Annulée',
  'transaction.fallbackType': 'Écriture',
  'transaction.notFound': 'Transaction introuvable',
  'transaction.notFoundHelp': 'La transaction a peut-être été annulée, appartient à un autre exercice ou n\'est plus disponible.',
  'transaction.invoice': 'Facture',
  'transaction.purchase': 'Achat',
  'transaction.otherSale': 'Autre vente',
  'transaction.customs': 'Déclaration en douane',
  'transaction.openDocument': 'Voir le justificatif',
  'transaction.download': 'Télécharger',
  'transaction.upload': 'Téléverser une pièce jointe',
  'transaction.uploaded': 'Pièce jointe téléversée.',
  'transaction.uploadFailed': 'Impossible de téléverser la pièce jointe.',
  'transaction.documentFailed': 'Impossible de récupérer le justificatif depuis le serveur.',
  'transaction.previewFailed': 'Impossible d\'afficher le justificatif.',
  'transaction.lost': 'Justificatif perdu',
  'transaction.lostPrompt': 'Explication pour le journal (facultatif) :',
  'transaction.lostSaved': 'Le justificatif a été marqué comme perdu.',
  'transaction.lostFailed': 'Impossible de marquer le justificatif comme perdu.',
  'transaction.annul': 'Annuler la transaction',
  'transaction.annulQuestion': 'Annuler la transaction ?',
  'transaction.creditQuestion': 'Émettre un avoir sur la facture ?',
  'transaction.credit': 'Émettre un avoir',
  'transaction.annulling': 'Annulation...',
  'transaction.annulHelp': 'La transaction est annulée et conservée dans l\'historique, mais exclue de la base des rapports.',
  'transaction.creditHelp': 'La facture est annulée par un avoir créé en brouillon, à vérifier avant l\'envoi.',
  'transaction.creditDraft': 'L\'avoir a été créé en brouillon. Vérifiez-le et envoyez-le depuis la liste des factures.',
  'transaction.annulledSaved': 'La transaction a été annulée.',
  'transaction.annulFailed': 'Impossible d\'annuler la transaction.',
  'transaction.privateReimbursed': 'Le débours privé a été remboursé.',
  'transaction.privateReimburseFailed': 'Impossible de rembourser le débours privé.',
  'transaction.reimbursePrivate': 'Rembourser le débours privé',
  'transaction.reimbursePrivateHelp': 'Comptabilise le remboursement depuis le compte bancaire de l\'entreprise choisi en contrepartie du compte 2060, sans comptabiliser à nouveau la charge ni la TVA.',
  'transaction.paymentDate': 'Date de paiement',
  'transaction.bankAccount': 'Compte bancaire',
  'transaction.goTo': 'Aller à',
  'transaction.bank': 'Banque',
  'transaction.vat': 'TVA',
  'transaction.yearEnd': 'Clôture annuelle',
});
